import React from "react";
import { inject, observer } from "mobx-react";
import { appConfig } from "../config";
import { dateFormat } from "../helpers";
import { Loading } from "../Components/Loading";
import "../app.css";
import ApiService from "../services/api.service";

@inject("AppStore")
@observer
class Builds extends React.Component {
  store = this.props.AppStore;
  apiService = new ApiService();

  async componentDidMount() {
    const user = await this.apiService.checkUser();
    if (!user) {
      window.location.href = "/account/login";
    }

    const { location } = this.props.match.params;

    this.store.getLocation(location);
    this.store.loadConfig();

    this.store.getBuilds();
  }

  render() {
    const { page } = this.store;

    if (page.loading) return <Loading />;

    return (
      <div className="app">
        <div className="header">
          <div className="logo-wrapper">
            <a
              href={`${appConfig.locale.url}/${this.store.location_name}`}
              style={{
                display: "flex",
                alignItems: "center",
                color: "#000",
                textDecoration: "none",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              {this.store.configuration && this.store.configuration.logo && (
                <img
                  alt="logo"
                  src={appConfig.locale.api + this.store.configuration.logo.url}
                  className="logo"
                />
              )}
              <span>
                {this.store.location && this.store.location.displayname}
              </span>
            </a>
          </div>
          {this.store.user ? (
            <div className="header-user">
              <span>{this.store.user.user.fullname} -&nbsp;</span>
              <a onClick={this.store.logout}>LOGOUT</a>
            </div>
          ) : (
            <div className="header-user">
              <a href={`/${this.store.location_name}/account`}>Account</a>
            </div>
          )}
        </div>
        <div className={`content ${this.store.selectedModel && "open"}`}>
          <div className="modelSelector__filter">
            <div style={{ padding: 20, background: "#fff", width: 150 }}>
              <form onSubmit={this.store.onFilterBuilds}>
                <div className="form-item">
                  <label>Filter</label>
                  <input
                    type="text"
                    name="phone"
                    style={{
                      padding: 10,
                      width: "100%",
                      boxSizing: "border-box",
                    }}
                    value={this.store.buildPage.search}
                    onChange={(e) =>
                      (this.store.buildPage.search = e.target.value)
                    }
                  />
                </div>
                <div style={{ marginTop: 20 }}>
                  <button
                    type="submit"
                    className="button__clean"
                    style={{
                      width: "100%",
                      textAlign: "center",
                      padding: "10px",
                    }}
                  >
                    SEARCH
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div
            className="modelSelector__left"
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ padding: 50 }}>
              <table className="order-table">
                <thead>
                  <tr>
                    <th>
                      <a
                        className="sort"
                        href="#"
                        onClick={(e) =>
                          this.store.onSortBuilds(e, "order_number")
                        }
                      >
                        Order#
                        {this.store.builds_sort == "order_number" &&
                          (this.store.builds_sort_direction == "asc" ? (
                            <i className="fa-solid fa-chevron-up"></i>
                          ) : (
                            <i className="fa-solid fa-chevron-down"></i>
                          ))}
                      </a>
                    </th>
                    <th>
                      <a
                        className="sort"
                        href="#"
                        onClick={(e) => this.store.onSortBuilds(e, "date")}
                      >
                        Date
                        {this.store.builds_sort == "date" &&
                          (this.store.builds_sort_direction == "asc" ? (
                            <i className="fa-solid fa-chevron-up"></i>
                          ) : (
                            <i className="fa-solid fa-chevron-down"></i>
                          ))}
                      </a>
                    </th>
                    <th>
                      <a
                        className="sort"
                        href="#"
                        onClick={(e) => this.store.onSortBuilds(e, "firstname")}
                      >
                        Customer
                        {this.store.builds_sort == "firstname" &&
                          (this.store.builds_sort_direction == "asc" ? (
                            <i className="fa-solid fa-chevron-up"></i>
                          ) : (
                            <i className="fa-solid fa-chevron-down"></i>
                          ))}
                      </a>
                    </th>
                    <th>
                      <a
                        className="sort"
                        href="#"
                        onClick={(e) => this.store.onSortBuilds(e, "email")}
                      >
                        Email
                        {this.store.builds_sort == "email" &&
                          (this.store.builds_sort_direction == "asc" ? (
                            <i className="fa-solid fa-chevron-up"></i>
                          ) : (
                            <i className="fa-solid fa-chevron-down"></i>
                          ))}
                      </a>
                    </th>
                    <th>Url</th>
                  </tr>
                </thead>
                <tbody>
                  {this.store.filtered_builds.map(
                    (b, i) =>
                      b.slug && (
                        <tr key={i} data-boat={JSON.stringify(b)}>
                          <td>{b.order_number}</td>
                          <td>{dateFormat(b.date)}</td>
                          <td>
                            {b.firstname} {b.lastname}
                          </td>
                          <td>{b.email}</td>
                          <td>
                            <a
                              href={`/${b.location}/build/${b.slug}/${b.order_number}`}
                              target="_blank"
                            >
                              Order Form
                            </a>
                          </td>
                        </tr>
                      )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Builds;
